<template>
    <div class="tagsDiv">
        <el-form :model="form" :rules="rulesT" ref="ruleFormT" class="demo-form-inline">
            <el-form-item class="tagsItem">
                <el-select v-model="form.labelType" style="margin-right: 5px;width: 140px" placeholder="请选择标签类型" @change="typeChange">
                    <el-option
                            v-for="item in labelTypeList"
                            :label="item.name"
                            :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="form.conditionType" style="margin-right: 5px;width: 140px" placeholder="请选择标条件" >
                    <el-option
                            v-for="item in conditionList"
                            :label="item.name"
                            :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-if="conditionType == 'sex'" v-model="form.sex" placeholder="请选择条件值">
                    <el-option label="男" value="1"></el-option>
                    <el-option label="女" value="2"></el-option>
                </el-select>
                <el-select v-if="conditionType == 'user_type'" v-model="form.userType" placeholder="请选择条件值">
                    <el-option label="学生" value="0"></el-option>
                    <el-option label="教职工" value="2"></el-option>
                </el-select>
                <el-form-item ref="deptListv" prop="deptList" >
                    <TreeSelect v-if="conditionType == 'dept'" size="small" :data="departmentData"
                                clearable
                                multiple
                                expandAll
                                ref="deptDouble"
                                :obj="mapKey"
                                checkStrictly
                                collapseTags
                                @getValue="setDeptDoubleMenu">
                    </TreeSelect>
                </el-form-item>
                <el-form-item prop="name">
                    <el-input v-model="form.name" v-if="conditionType == 'name'" style="width: 180px"></el-input>
                </el-form-item>
                <el-form-item prop="year">
                    <el-input v-model="form.year" maxlength="3" type="number" v-if="conditionType == 'adm_date'" style="width: 180px"></el-input>
                </el-form-item>
                <el-form-item prop="age">
                    <el-input v-model="form.age" maxlength="3" type="number" v-if="conditionType == 'age'" style="width: 180px"></el-input>
                </el-form-item>
                <el-form-item v-if="conditionType == 'role'" ref="roleListv" prop="roleList">
                    <el-input
                            placeholder="请选择角色"
                            style="width: 180px"
                            v-model="form.role"
                            @focus=" isShowCheck= true"
                    ></el-input>
                    <CheckBox :data="roleList"
                              :title="'选择角色'"
                              :isShowCheck="isShowCheck"
                              @setShow="setCkeckShow"
                              @getValue="setCheckValue"></CheckBox>
                </el-form-item>
                <el-button @click="addTags" type="primary" size="small" style="margin-left: 5px;margin-bottom: 18px">+</el-button>
            </el-form-item>
        </el-form>
        <div>
            <el-table
                    :data="tableData"
                    style="width: 100%">
                <el-table-column
                        prop="labelType"
                        label="条件"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="conditionType"
                        label="比较条件"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="sexText"
                        label="条件值">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="120">
                    <template slot-scope="scope">
                        <el-button
                                @click.native.prevent="deleteRow(scope.$index, tableData)"
                                type="text"
                                size="small">
                            移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import TreeSelect from "@/components/TreeSelect.vue";
    import CheckBox from "@/components/CheckBox.vue";
    import { getDeptTree, getRoleList} from '@/api/managementCenter/otherApi';
    export default {
        name: "tags",
        components: {TreeSelect, CheckBox},
        data(){
            return {
                form: {
                    conditionType:"eq", //条件类型
                    labelType: "name", //字段类型
                    sex: '', //男女条件值
                    name: '', //姓名条件值
                    age: '', //年龄条件值
                    year: '', //入职年份条件值
                    role: '', //角色
                    userType: '', //用户类型
                    dept: [], //条件值部门
                },
                deptList: '',
                roleData: '',
                rulesT: {
                    year: [
                        { required: true, message: "请输入入职年份条件值", trigger: "blur" }
                    ],
                    name: [
                        { required: true, message: "请输入姓名", trigger: "blur" }
                    ],
                    deptList: [
                        { required: true, message: "请选择部门", trigger: "change" }
                    ],
                    age: [
                        { required: true, message: "请输入年龄值", trigger: "blur" }
                    ],
                    sex: [
                        { required: true, message: "请选择性别值", trigger: "change" }
                    ],
                    roleList: [
                        { required: true, message: "请选择角色", trigger: "change" }
                    ]
                },
                labelTypeList:[
                    {
                        name:'名称',
                        value:'name'
                    },
                    {
                        name:'性别',
                        value:'sex'
                    },
                    {
                        name:'年龄',
                        value:'age'
                    },
                    {
                        name:'部门',
                        value:'dept'
                    },
                    {
                        name:'角色',
                        value:'role'
                    },
                    {
                        name:'用户类型',
                        value:'user_type'
                    },
                    {
                        name:'入学入职年份',
                        value:'adm_date'
                    }
                ],
                conditionList: [],
                conditionType: 'name',
                textValueList: [],
                conditionData: [
                    {
                        value: 'name',
                        list: [
                            {
                                name: '等于',
                                value: 'eq'
                            },
                            {
                                name: '不等于',
                                value: 'neq'
                            }
                        ]
                    },
                    {
                        value: 'sex',
                        list: [
                            {
                                name: '等于',
                                value: 'eq'
                            }
                        ]
                    },
                    {
                        value: 'age',
                        list: [
                            {
                                name: '等于',
                                value: 'eq'
                            },
                            {
                                name: '模糊匹配',
                                value: 'gt'
                            },
                            {
                                name: '大于',
                                value: 'lt'
                            },
                            {
                                name: '大于等于',
                                value: 'gte'
                            },
                            {
                                name: '小于等于',
                                value: 'lte'
                            }
                        ]
                    },
                    {
                        value: 'dept',
                        list: [
                            {
                                name: '本部门',
                                value: 'deplevel'
                            },
                            {
                                name: '本部门以及下级部门',
                                value: 'depdownlevel'
                            }
                        ]
                    },
                    {
                        value: 'role',
                        list: [
                            {
                                name: '存在',
                                value: 'in'
                            },
                            {
                                name: '不存在',
                                value: 'nin'
                            }
                        ]
                    },
                    {
                        value: 'user_type',
                        list: [
                            {
                                name: '等于',
                                value: 'eq'
                            }
                        ]
                    },
                    {
                        value: 'adm_date',
                        list: [
                            {
                                name: '等于',
                                value: 'eq'
                            },
                            {
                                name: '模糊匹配',
                                value: 'gt'
                            },
                            {
                                name: '大于',
                                value: 'lt'
                            },
                            {
                                name: '大于等于',
                                value: 'gte'
                            },
                            {
                                name: '小于等于',
                                value: 'lte'
                            }
                        ]
                    }
                ],
                tableData:[],
                mapKey:{
                    id:'id',// ID
                    label: 'name',// 显示名称
                    children: 'children', //子级字段名
                },
                departmentData:[],
                isShowCheck:false,
                roleList: [],
                conditions: []
            }
        },
        mounted() {
            this.getDeptTreeData()
            this.getUserData()
            this.conditionList = this.conditionData[0].list
        },
        methods: {
            //获取角色数据
            getUserData(){
                getRoleList().then(({data})=>{
                    if(data.code == 0){
                        this.roleList = data.data.map(i=>{
                            return {
                                id: i.roleId,
                                name: i.roleName
                            }
                        })
                    }
                }).catch(err=>{

                })
            },
            //获取复选框数据
            setCheckValue(ids,value){
                if(ids.length == 0){
                    this.$refs['ruleFormT'].validateField('postList');
                    this.form.role = ''
                    this.roleData = ''
                }else {
                    this.$refs['roleListv'].resetField()
                    this.roleData = ids
                    this.form.role = value.toString()
                }
            },
            setCkeckShow(value){
                this.isShowCheck = value
            },
            //获取部门数据
            getDeptTreeData(){
                getDeptTree().then(({data})=>{
                    if(data.code == 0){
                        if(data.data&&data.data.length>0) {
                            if(data.data[0].id==1){
                                this.departmentData = data.data[0].children;
                            }else{
                                this.departmentData = data.data
                            }
                        }

                    }
                }).catch(err=>{

                })

            },
            setDeptDoubleMenu(key,data){//获取子组件值
                // this.doubleSelect = data.map(item=>item.id)
                if(key.length == 0){
                    this.$refs['ruleFormT'].validateField('deptList');
                }else {
                    this.$refs['deptListv'].resetField()
                    this.deptList = key
                    this.form.dept = data.map((item) =>{
                        return item.name
                    })
                }
            },
            //字段类型改变事件
            typeChange(value){
                this.conditionType = value
                this.$refs['ruleFormT'].resetFields()
                this.conditionData.forEach((item) =>{
                    if(item.value == value) {
                        this.conditionList = item.list
                        this.form.conditionType = item.list[0].value
                    }
                })
            },
            //添加标签条件
            addTags(){
                let that = this
                if(this.conditions.length == 0){
                    this.addfun()
                }else {
                    //判定该类型标签是否创建
                    let result =this.conditions.some(function (item) {
                         if(item.condition == that.conditionType) {return true}
                    })
                    if(result) {
                        this.$message.error(  "该标签已被创建!" )
                    }else {
                        this.addfun()
                    }
                }
            },
            addfun(){
                let name = '' //条件选择值
                let val = ''  // 比较条件值
                let text = '' // 条件值
                let textName = '' //条件值中文，便于查询详情时回显
                //匹配表格中条件字段
                this.labelTypeList.forEach((item) =>{
                    if(item.value == this.form.labelType) {
                        name = item.name
                    }
                })
                //匹配表格中比较条件字段
                this.conditionData.forEach((item) =>{
                    if(item.value == this.conditionType) {
                        item.list.forEach((i) =>{
                            if(i.value == this.form.conditionType) {
                                val = i.name
                            }
                        })
                    }
                })
                //匹配表格中条件值字段
                if(this.conditionType == 'name') { // 姓名条件
                    if(this.form.name == '') {
                        this.$message.error(  "请完善条件设置!" );
                    }else {
                        this.tableData.push({
                            labelType: name,
                            conditionType: val,
                            sexText: this.form.name
                        })
                        text = this.form.name
                        textName = this.form.name
                    }
                }
                if(this.conditionType == 'sex') { // 性别条件
                    if(this.form.sex == '') {
                        this.$message.error(  "请完善条件设置!" );
                    }else {
                        this.tableData.push({
                            labelType: name,
                            conditionType: val,
                            sexText: this.form.sex === '1' ? '男' : '女'
                        })
                        text = this.form.sex
                        textName = this.form.sex === '1' ? '男' : '女'
                    }
                }
                if(this.conditionType == 'age') { // 年龄条件
                    if(this.form.age == '') {
                        this.$message.error(  "请完善条件设置!" );
                    }else {
                        this.tableData.push({
                            labelType: name,
                            conditionType: val,
                            sexText: this.form.age
                        })
                        text = this.form.age
                        textName = this.form.age
                    }
                }
                if(this.conditionType == 'dept') { // 部门条件
                    if(this.form.dept.length == 0) {
                        this.$message.error(  "请完善条件设置!" );
                    }else {
                        this.tableData.push({
                            labelType: name,
                            conditionType: val,
                            sexText: this.form.dept
                        })
                        text = this.deptList.join(',')
                        textName = this.form.dept.toString()
                    }
                }
                if(this.conditionType == 'role') { // 角色条件
                    if(this.form.role == '') {
                        this.$message.error(  "请完善条件设置!" );
                    }else {
                        this.tableData.push({
                            labelType: name,
                            conditionType: val,
                            sexText: this.form.role
                        })
                        text = this.roleData.join(',')
                        textName = this.form.role
                    }
                }
                if(this.conditionType == 'user_type') { // 用户类型条件
                    if(this.form.userType == '') {
                        this.$message.error(  "请完善条件设置!" );
                    }else {
                        this.tableData.push({
                            labelType: name,
                            conditionType: val,
                            sexText: this.form.userType == '0' ? '学生' : '教职工'
                        })
                        text = this.form.userType
                        textName = this.form.userType == '0' ? '学生' : '教职工'
                    }
                }
                if(this.conditionType == 'adm_date') { // 入职年份条件
                    if(this.form.year == '') {
                        this.$message.error(  "请完善条件设置!" );
                    }else {
                        this.tableData.push({
                            labelType: name,
                            conditionType: val,
                            sexText: this.form.year
                        })
                        text = this.form.year
                        textName = this.form.year
                    }
                }
                this.conditions.push({
                    condition: this.form.labelType,
                    conditionName: name,
                    description: '',
                    compare: this.form.conditionType,
                    campareName: val,
                    value: text,
                    textName: textName
                })
                this.$emit('setTagsData',this.conditions);
            },
            //移除标签条件
            deleteRow(index, rows) {
                this.conditions.splice(index,1)
                rows.splice(index, 1);
                this.$emit('setTagsData',this.conditions);

            }
        }
    }
</script>

<style>

.el-form-item--small .el-form-item__content{
    display: flex !important;

}
</style>